export function removeDuplicates(items) {
  const map = {};
  for (const it of items) {
    if (!it || it.id == null) continue;
    map[it.id] = it;
  }
  return Object.values(map);
}
